var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6842 9.2807L17.614 6.33333C16.1754 4.92982 14.2281 4 12 4C7.5614 4 4 7.5614 4 12C4 16.4386 7.5614 20 12 20C14.2632 20 16.193 19.1053 17.6491 17.6667C17.8421 17.4737 17.9474 17.2281 17.9474 16.9474C17.9474 16.4035 17.4912 15.9474 16.9474 15.9474C16.6667 15.9474 16.4211 16.0526 16.2456 16.2281C15.0702 17.386 13.7544 18 12 18C8.54386 18 6 15.4561 6 12C6 8.54386 8.54386 6 12 6C13.7193 6 15.0526 6.63158 16.2456 7.77193L19.3158 10.7193C19.4912 10.8947 19.7368 11 20 11C20.5439 11 21 10.5439 21 10C21 9.7193 20.8772 9.45614 20.6842 9.2807ZM21 10V6C21 5.45614 20.5439 5 20 5C19.4561 5 19 5.45614 19 6V10C19 10.5439 19.4561 11 20 11C20.5439 11 21 10.5439 21 10ZM16 11H20C20.5439 11 21 10.5439 21 10C21 9.45614 20.5439 9 20 9H16C15.4561 9 15 9.45614 15 10C15 10.5439 15.4561 11 16 11Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshOutlined);
export default __webpack_public_path__ + "static/media/refresh_outlined.1249991c.svg";
export { ForwardRef as ReactComponent };